module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av439-29ff554bbad5f0f1217610f4f75ab19a.jpg";